import React from 'react';
import FullscreenWrapper from './fullscreenWrapper';
import { getResizeMediaUrl, } from '@wix/photography-client-lib';
var dummyItems = [
    {
        "itemId": "dataItem-l0l2hd62",
        "mediaUrl": "https://static.wixstatic.com/media/11062b_049e75ff426d48d1a794debb05897c8c~mv2_d_4505_3003_s_4_2.jpg",
        "orderIndex": 0,
        "metaData": {
            "type": "image",
            "height": 3003,
            "width": 4505,
            "title": "Spring Fashion",
            "description": "Some description",
            "sourceName": "private",
            "link": {
                "type": "web"
            }
        }
    }
];
var container = {
    width: 1000,
    height: 600
};
export default function FullscreenPreviewWrapper(props) {
    return (React.createElement("div", { style: {
            width: container.width,
            height: container.height,
        }, key: JSON.stringify(props.options) },
        React.createElement(FullscreenWrapper, { style: { position: 'static' }, options: props.options, deviceType: 'DESKTOP', items: dummyItems, createMediaUrl: getResizeMediaUrl, setFullscreenIdx: function () { }, container: container })));
}
//# sourceMappingURL=fullscreenPreviewWrapper.js.map